import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class EglenceVergisiTarifeleriAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "EglenceTarifeListe";
        super(baseUrl);
    }


    getEglenceVergisiTarifeleriListe(yili?: number) {

        return this.get("", { params: { yili: yili } });


    }

}
export default new EglenceVergisiTarifeleriAPI();